/* tempexp_15344-full-file */
export const SUCCESS_AUTH_WHEN_DOWNLOAD = 'success_auth_when_download';
